/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

export default class ExpandableCard extends Component {
  // passed in
  title = null;

  subtitle = null;
  count = null;
  resetKey = null;

  // Optional initial expanded state; defaults to expanded to preserve the
  // existing behaviour. Pass @initiallyExpanded={{false}} to start collapsed.
  initiallyExpanded = true;

  // Optional: pass @allowOverflow={{true}} so dropdowns and menus inside the
  // card can open past its edge. By default content is clipped to the
  // rounded corners.
  allowOverflow = false;

  // state
  @tracked
  isExpanded = true;

  _prevResetKey;

  init() {
    super.init(...arguments);
    this.isExpanded = this.initiallyExpanded;
  }

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    if (
      this._prevResetKey !== undefined &&
      this._prevResetKey !== this.resetKey
    ) {
      this.isExpanded = true;
    }
    this._prevResetKey = this.resetKey;
  }

  @action
  toggle() {
    this.toggleProperty('isExpanded');
  }
}
